import { CallApi, handleJSONResponse } from './common';
import { Product } from '@services/product/types/product';
import { Coupon } from '../../../../services/product/types/coupon';

const callAPI = CallApi('products');
// const callAPIExtra = CallApi('products-compare');

export const list = async (): Promise<Product[]> => {
  const response = await callAPI('/', 'GET');

  return handleJSONResponse(response);
};

export const extraFeatures = async (): Promise<any> => {
  const response = await callAPI('/compare', 'GET');

  return handleJSONResponse(response);
};
export const listCoupons = async (): Promise<Coupon[]> => {
  const response = await callAPI('/coupons', 'GET');

  return handleJSONResponse(response);
};
